import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Container, Stack, Typography, TextField, Box } from "@mui/material";
import BullseyeIcon from "assets/images/icons/bullseye.svg";

import { setMissionStatement, selectMissionStatement, selectFieldError, setErrorFields } from "../slice";

const MissionStatementStep = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const missionStatement = useSelector(selectMissionStatement);
    const fieldError = useSelector(selectFieldError);

    return (
        <Container maxWidth="sm" sx={{ my: 3 }}>
            <Stack alignItems="center" gap={1.5}>
                <img src={BullseyeIcon} alt="Bullseye" width={35} height={35} />
                <Typography fontWeight="500" color="text.mediumDark">
                    Tell us your mission
                </Typography>
                <TextField
                    color="secondary"
                    value={missionStatement}
                    onChange={(e) => {
                        dispatch(setMissionStatement(e.target.value));
                        dispatch(setErrorFields({ mission: "" }));
                    }}
                    placeholder="Our mission is to..."
                    multiline
                    minRows={5}
                    fullWidth
                    error={!!fieldError.mission}
                    // inputProps={{ maxLength: 5000 }}
                    // helperText={`${missionStatement?.length || 0}/5000`}
                    // FormHelperTextProps={{
                    //     sx: { textAlign: 'right' }
                    // }}
                />
            </Stack>
            {fieldError.mission && (
                <Box mt={1}>
                    <Typography color="error" variant="caption">
                        {t(fieldError.mission)}
                    </Typography>
                </Box>
            )}
        </Container>
    );
};

export default MissionStatementStep;
